import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["selectAll", "roomSelect", "item"];

  connect() {
    this.updateAllSelectAllStates();
    this.updateAllRoomStates();
    console.log("SalesSelectAllController connected");
  }

  toggleAll(event) {
    const isChecked = event.target.checked;
    const section = event.target.dataset.section;

    this.getItemsForSection(section).forEach((checkbox) => {
      checkbox.checked = isChecked;
    });

    this.getRoomSelectsForSection(section).forEach((checkbox) => {
      checkbox.checked = isChecked;
    });
  }

  toggleRoom(event) {
    const isChecked = event.target.checked;
    const room = event.target.dataset.room;
    const section = event.target.dataset.section;

    this.getItemsForRoom(room, section).forEach((checkbox) => {
      checkbox.checked = isChecked;
    });

    this.updateSelectAllStateForSection(section);
  }

  updateSelectAll() {
    this.updateAllSelectAllStates();
    this.updateAllRoomStates();
  }

  updateAllSelectAllStates() {
    this.selectAllTargets.forEach((selectAll) => {
      const section = selectAll.dataset.section;
      this.updateSelectAllStateForSection(section);
    });
  }

  updateSelectAllStateForSection(section) {
    const sectionItems = this.getItemsForSection(section);
    const checkedItems = sectionItems.filter((checkbox) => checkbox.checked);
    const allChecked =
      sectionItems.length > 0 && checkedItems.length === sectionItems.length;

    const selectAllCheckbox = this.selectAllTargets.find(
      (target) => target.dataset.section === section
    );
    if (selectAllCheckbox) {
      selectAllCheckbox.checked = allChecked;
    }
  }

  updateAllRoomStates() {
    this.roomSelectTargets.forEach((roomCheckbox) => {
      this.updateRoomState(roomCheckbox);
    });
  }

  updateRoomState(roomCheckbox) {
    const room = roomCheckbox.dataset.room;
    const section = roomCheckbox.dataset.section;
    const roomItems = this.getItemsForRoom(room, section);
    const checkedRoomItems = roomItems.filter((checkbox) => checkbox.checked);

    roomCheckbox.checked =
      roomItems.length > 0 && checkedRoomItems.length === roomItems.length;
  }

  getItemsForSection(section) {
    return this.itemTargets.filter((item) => item.dataset.section === section);
  }

  getRoomSelectsForSection(section) {
    return this.roomSelectTargets.filter(
      (roomSelect) => roomSelect.dataset.section === section
    );
  }

  getItemsForRoom(room, section) {
    return this.itemTargets.filter(
      (item) => item.dataset.room === room && item.dataset.section === section
    );
  }
}
